<template>
  <vx-card id="print-report" class="w-full">
    <!-- 실시현황 -->
    <div class="flex flex-wrap items-center mb-3 gap-2">
      <h5><i class="dot"></i>실시현황</h5>
      <div class="ml-auto flex items-center justify-center gap-3">
        <vs-select class="w-full" v-model="selectedYear" autocomplete @change="reloadPost">
          <vs-select-item v-for="year in years" :key="`year-${year}`" :value="year" :text="year" />
        </vs-select>
        <vs-select class="w-full" v-model="selectedHalf" autocomplete @change="reloadPost">
          <vs-select-item value="상반기" text="상반기" />
          <vs-select-item value="하반기" text="하반기" />
        </vs-select>
      </div>
    </div>

    <div class="w-full overflow-x-auto">
      <table>
        <colgroup>
          <col width="200" />
          <col width="100" />
          <col width="100" />
          <col width="60" />
          <col width="60" />
          <col width="60" />
          <col width="60" />
          <col width="60" />
          <col width="60" />
          <col width="60" />
          <col width="60" />
          <col width="60" />
          <col width="60" />
          <col width="60" />
          <col width="60" />
          <col width="60" />
          <col width="60" />
          <col width="60" />
          <col width="60" />
          <col width="60" />
          <col width="60" />
        </colgroup>
        <thead>
        <tr>
          <th rowspan="2">구분</th>
          <th colspan="2" style="width: 25%">산업안전보건위원회(1회/분기)</th>
          <th colspan="6" style="width: 25%">안전보건협의체(1회/월)</th>
          <th colspan="6" style="width: 25%">설비안전위원회(1회/월)</th>
          <th colspan="6" style="width: 25%">크레인안전협의체(1회/2개월)</th>
        </tr>
        <tr>
          <th>{{ selectedHalf === "상반기" ? "1분기" : "3분기" }}</th>
          <th>{{ selectedHalf === "상반기" ? "2분기" : "4분기" }}</th>
          <th v-for="_ in selectedHalf === '상반기' ? 6 : getNumbers(7, 13)" :key="`month1_${_}`">{{ _ }}월</th>
          <th v-for="_ in selectedHalf === '상반기' ? 6 : getNumbers(7, 13)" :key="`month2_${_}`">{{ _ }}월</th>
          <th v-for="_ in selectedHalf === '상반기' ? 6 : getNumbers(7, 13)" :key="`month3_${_}`">{{ _ }}월</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, key, index) in list" :key="index">
          <td class="bg-th">{{ item.label }}</td>
          <td v-for="(산업, 산업_i) in item.산업안전보건위원회" :key="`${index}_${item.label}_산업_${산업_i}`">
            <div v-if="산업" class="flex items-center justify-center">
              <div class="circle"></div>
            </div>
          </td>
          <td v-for="(안전, 안전_i) in item.안전보건협의체" :key="`${index}_${item.label}_안전_${안전_i}`">
            <div v-if="안전" class="flex items-center justify-center">
              <div class="circle"></div>
            </div>
          </td>
          <td v-for="(설비, 설비_i) in item.설비안전위원회" :key="`${index}_${item.label}_설비_${설비_i}`">
            <div v-if="설비" class="flex items-center justify-center">
              <div class="circle"></div>
            </div>
          </td>
          <td v-for="(크레인, 크레인_i) in item.크레인안전협의체" :key="`${index}_${item.label}_크레인_${크레인_i}`">
            <div v-if="크레인" class="flex items-center justify-center">
              <div class="circle"></div>
            </div>
          </td>
        </tr>
        <tr v-if="0 === Object.keys(list).length">
          <td colspan="21">표시할 데이터가 없습니다.</td>
        </tr>
        </tbody>
      </table>
    </div>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      selectedYear: new Date().getFullYear(),
      years: [],
      selectedHalf: "상반기",

      list: {
        // 0: {
        //   label: "Test",
        //   산업안전보건위원회: [false, false],
        //   안전보건협의체: [false, false, false, false, false, false],
        //   설비안전위원회: [false, false, false, false, false, false],
        //   크레인안전협의체: [false, false, false, false, false, false],
        // },
      },
    };
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
  },
  created() {
    this.generateYears();
    this.reloadPost();
  },
  methods: {
    generateYears() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 50;
      for (let year = currentYear; year >= startYear; year--) {
        this.years.push(year);
      }
    },

    getNumbers(start, stop) {
      return new Array(stop - start).fill(start).map((n, i) => n + i);
    },

    __initReloadPostMergeData(label) {
      return {
        label,
        산업안전보건위원회: [false, false],
        안전보건협의체: [false, false, false, false, false, false],
        설비안전위원회: [false, false, false, false, false, false],
        크레인안전협의체: [false, false, false, false, false, false],
      }
    },
    async reloadPost() {
      const [산업안전보건위원회, 안전보건협의체, 설비안전위원회, 크레인안전협의체] = await Promise.all([this.loadPost(818), this.loadPost(819), this.loadPost(820), this.loadPost(821)]);
      const mergeData = {};

      // =============== 산업안전보건위원회 =====================
      for (const fieldId in 산업안전보건위원회) {
        const data = 산업안전보건위원회[fieldId];
        // 데이터가 존재하지 않으면 초기화한다.
        if (!mergeData[fieldId]) mergeData[fieldId] = this.__initReloadPostMergeData(data.label);

        if (this.selectedHalf === "상반기") {
          // 1~3 4~6
          mergeData[fieldId].산업안전보건위원회 = [data.data[0] || data.data[1] || data.data[2], data.data[3] || data.data[4] || data.data[5]];
        } else {
          // 7~9 10~12
          mergeData[fieldId].산업안전보건위원회 = [data.data[6] || data.data[7] || data.data[8], data.data[9] || data.data[10] || data.data[11]];
        }
      }

      // =============== 안전보건협의체 =====================
      for (const fieldId in 안전보건협의체) {
        const data = 안전보건협의체[fieldId];
        // 데이터가 존재하지 않으면 초기화한다.
        if (!mergeData[fieldId]) mergeData[fieldId] = this.__initReloadPostMergeData(data.label);

        if (this.selectedHalf === "상반기") {
          // 1~3 4~6
          mergeData[fieldId].안전보건협의체 = data.data.slice(0, 6);
        } else {
          // 7~9 10~12
          mergeData[fieldId].안전보건협의체 = data.data.slice(6, 12);
        }
      }

      // =============== 설비안전위원회 =====================
      for (const fieldId in 설비안전위원회) {
        const data = 설비안전위원회[fieldId];
        // 데이터가 존재하지 않으면 초기화한다.
        if (!mergeData[fieldId]) mergeData[fieldId] = this.__initReloadPostMergeData(data.label);

        if (this.selectedHalf === "상반기") {
          // 1~3 4~6
          mergeData[fieldId].설비안전위원회 = data.data.slice(0, 6);
        } else {
          // 7~9 10~12
          mergeData[fieldId].설비안전위원회 = data.data.slice(6, 12);
        }
      }

      // =============== 크레인안전협의체 =====================
      for (const fieldId in 크레인안전협의체) {
        const data = 크레인안전협의체[fieldId];
        // 데이터가 존재하지 않으면 초기화한다.
        if (!mergeData[fieldId]) mergeData[fieldId] = this.__initReloadPostMergeData(data.label);

        if (this.selectedHalf === "상반기") {
          // 1~3 4~6
          mergeData[fieldId].크레인안전협의체 = data.data.slice(0, 6);
        } else {
          // 7~9 10~12
          mergeData[fieldId].크레인안전협의체 = data.data.slice(6, 12);
        }
      }

      this.list = JSON.parse(JSON.stringify(mergeData));
    },

    // 게시물 불러오기 (818,819,820,821)
    async loadPost(boardId) {
      if (!this.selectedYear) return;

      const projectId = this.$route.params.proj_id;
      const page = 1;
      const perPage = 10000;
      const dateTarget = boardId === 818 ? "body.quaterDate" : "body.monthDate";
      let dateBegin = `${this.selectedYear}-${this.selectedHalf === "상반기" ? "01" : "07"}-01`;
      let dateEnd = `${this.selectedYear}-${this.selectedHalf === "상반기" ? "06-30" : "12-31"}`;

      const conditions = [];
      conditions.push({ key: dateTarget, operator: ">=", value: dateBegin });
      conditions.push({ key: dateTarget, operator: "<=", value: dateEnd });

      await this.$store.dispatch("board/LOAD_POST_LIST", { projectId, boardId, page, perPage, conditions });
      const list = this.$store.state.board.postListInfo.data;

      let _datas = {};

      if (0 < list.length) {
        list.map((data) => {
          const filedId = data.field_id;
          const content = JSON.parse(data.post_content);
          if (!_datas[filedId]) {
            _datas[filedId] = {
              label: data.field.field_name,
              data: [false, false, false, false, false, false, false, false, false, false, false, false],
            };
          }
          _datas[filedId].data[Number(content.header.month) - 1] = true;
        });
      }
      return _datas;
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  width: calc(100% - 1px);
  table-layout: fixed;
  border-collapse: collapse;
  background: #fafafa;

  &,
  th,
  td {
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    padding: 14px;

    border: 1px solid #cdcdcd;
  }

  .editMode {
    padding: 7px;
  }

  th,
  .bg-th {
    background: #fafafa;
  }

  td {
    font-weight: 400;
    background: white;
  }
}

.circle {
  width: 10px;
  height: 10px;
  background: #28c76f;
  border-radius: 100%;
}
</style>
